const doc = [({"da":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"and_label":"Og", "or_label":"Eller"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;